export const CASHIER = "cashier";
export const REFILL = "refill.new_design.april_2021";
export const LOYALTY_OFFERS = "loyalty_offers";
export const MINTROUTE = "MINTROUTE";
export const LANDING = "landing_page";
export const MOS = "mos";
